import Icon from '../components/Icon.vue'

Icon.register({
  circle: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248z'
      }
    ]
  }
})
